import React,{useRef,useState} from 'react'
import {useDispatch} from 'react-redux'
import axios from 'axios'

import bg from '../../../images/study-img.jpeg'


const onLoginSubmit = (d) => {
  axios.post(
    '/login',{
      email:d.email,
      password:d.password,
      _csrf_token:d._csrf_token
    },{
      headers: {
        'X-AUTH-TOKEN': 'Login'
      }
    }
  ).then((r)=>{
    d.setLoader(!1);
    if(r.data.status){
      d.setApp({type:'_AUTH_LOGGED',payload: r.data.auth})
      document.querySelector('.popup-header .fa-times').click();
    }else{
      d.setError(r.data.msg)
    }
  })
}
const PopupLogin = ({show}) => {

  const setApp = useDispatch()
  const popupDefaultRef = useRef()
  const [email,setEmail] = useState('')
  const [password,setPassword] = useState('')
  const [error,setError] = useState(!1)
  const [loader,setLoader] = useState(!1)

  return (
    <>
      {
        !show ? null : (
          <div className="popup-child" style={{display:`${show === 'Login' ? '' : 'none'}`,opacity:`${show ? 1 : 0}`}}>
            <div className="popup-child-text">

              {
                error ? (
                  <div className="alert alert-danger" dangerouslySetInnerHTML={{__html:error}}/>
                ) : null
              }

              <form>
                <div className="form-group">
                  <label htmlFor="email"><b style={{fontWeight:500,color:'#836f35'}}><i className="fa fa-envelope-o"/> Email address</b></label>
                  <input onChange={(e)=>setEmail(e.target.value)} placeholder="Enter email address..." type="email" className="form-control" id="email" autoComplete="email" required="required" autoFocus/>
                </div>
                <div className="form-group">
                  <label htmlFor="password"><b style={{fontWeight:500,color:'#836f35'}}><i className="fa fa-key"/> Password</b></label>
                  <input onChange={(e)=>setPassword(e.target.value)} placeholder="Enter password..." type="password" className="form-control" id="password" required="required" autoComplete="current-password"/>
                  <small id="emailHelp" className="form-text display-block text-right">
                    <a href="/reset-password" style={{color:'#bf8800'}}>
                      Forgot password?
                    </a>
                  </small>
                </div>

              <br/>
                {
                  loader ? <div className="lds-dual-ring2"></div> : (
                    <button type="submit" onClick={
                      () => {
                        setLoader(1);
                        setError(!1);
                        onLoginSubmit({
                          email,password,
                          _csrf_token:window._csrf_token,
                          setError,
                          setLoader,
                          setApp
                        })
                      }
                    } className="btn btn-primary">Login</button>
                  )
                }
              </form>
            </div>
          </div>
        )
      }
    </>
  )
}
export default PopupLogin
